import { Link } from 'react-router-dom';

const CertificateCard = ({ item }) => {
    const student = item?.student;
    const isCompleted = item?.progress_percent === 100;

    return (
        <div className="bg-white p-4 rounded-xl shadow-md mb-4 flex items-center justify-between">
            <div>
                <h2 className="text-lg font-semibold">{item?.course_title}</h2>
                <p className="text-sm text-gray-500">
                    Student: {student?.first_name} {student?.last_name}
                </p>
                <p className="text-sm text-gray-600 mt-2">
                    Course Completion: {item?.progress_percent?.toFixed(2)}% completed
                </p>
            </div>

            {isCompleted ? (
                <Link
                    to={`/user/account/certificate/view/${item.enrollment_item_id}`}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                >
                    View Certificate
                </Link>
            ) : (
                <button
                    disabled
                    className="bg-gray-400 text-white px-4 py-2 rounded-lg cursor-not-allowed"
                    title="Complete the course to view the certificate"
                >
                    View Certificate
                </button>
            )}
        </div>
    );
};
export default CertificateCard;
